import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  IconButton,
} from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import Grid from "@mui/material/Grid2";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";



const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  boxShadow: "none",
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
}));

const AchievementsForm = ({ onChildData }) => {
  const [achievements, setAchievements] = useState([
    {
      name: '',
      description: '',
    },
  ]);

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updatedAchievements = [...achievements];
    updatedAchievements[index][name] = value;
    setAchievements(updatedAchievements);
    onChildData({ achievements : achievements });
  };

  const addAchievement = () => {
    setAchievements([
      ...achievements,
      {
        name: '',
        description: '',
      },
    ]);
  };

  const removeAchievement = (index) => {
    const updatedAchievements = achievements.filter((_, i) => i !== index);
    setAchievements(updatedAchievements);
    onChildData({ achievements : updatedAchievements });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const output = `achievements:\n${achievements.map(ach => `  - name: "${ach.name}"\n    description: "${ach.description}"`).join('\n')}`;
    console.log(output);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 3,pt:0,pb:2 }}>
      <Typography variant="h4" gutterBottom sx={{display:'none'}}>
        Achievements
      </Typography>
      <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography variant="h6">Achievements</Typography>
          </AccordionSummary>
          <AccordionDetails>
            
            {achievements.map((achievement, index) => (
        <Grid container spacing={2} key={index} sx={{ mb: 2 }}>
          <Grid size={12}>
            <Item>
            <TextField
              fullWidth
              label="Achievement Name"
              name="name"
              size='small'
             
              placeholder='Winner of an Irish public competition'
              value={achievement.name}
              onChange={(e) => handleChange(index, e)}
              required
            />
            </Item>
          </Grid>
          <Grid size={10}>
            <Item>
            <TextField
              fullWidth
              placeholder='Won first place in a public competition with a perfect score of 70/70, securing a Software Developer position at University Hospital Galway'
              multiline
              rows={4}
              label="Description"
              name="description"
              value={achievement.description}
              onChange={(e) => handleChange(index, e)}
              required
            />
            </Item>
          </Grid>
          <Grid size={2}>
            <Item>
            <IconButton onClick={() => removeAchievement(index)} color="error">
              <DeleteForeverIcon />
            </IconButton>
            </Item>
          
          </Grid>
        </Grid>
      ))}
               <Button variant="outlined" onClick={addAchievement} startIcon={<Add />} sx={{ mb: 2 }}>
        Add Achievement
      </Button>
         
          </AccordionDetails>
        </Accordion>
      
    
      <Button type="submit" variant="contained" sx={{display:'none'}}>
        Submit
      </Button>
    </Box>
  );
};

export default AchievementsForm;